module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-09.6f20ad79.svg";